import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import sorensen from "./views/sorensen.vue"
import levenshtein from "./views/levenshtein.vue"
import tensorflow from "./views/tensorflow.vue"
import privacyPolicy from "./views/PrivacyPolicy.vue"
import ContactUs from "./views/ContactUs.vue"
import AboutUs from "./views/AboutUs.vue"
import Development from "./views/Development.vue"
import Offer from "./views/Offer.vue"
import IntegrationSoftwareServices from "./views/IntegrationSoftwareServices.vue"

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    // {
    //   path: "/test",
    //   name: "components",
    //   components: {
    //     header: AppHeader,
    //     default: Components,
    //     footer: AppFooter
    //   }
    // },
    {
      path: "/",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      components: {
        header: AppHeader,
        default: privacyPolicy,
        footer: AppFooter
      }
    },
    {
      path: "/services",
      name: "services",
      components: {
        header: AppHeader,
        default: Development,
        footer: AppFooter
      }
    },
    {
      path: "/about-us",
      name: "about-us",
      components: {
        header: AppHeader,
        default: AboutUs,
        footer: AppFooter
      }
    },
    // {
    //   path: "/offer",
    //   name: "offer",
    //   components: {
    //     header: AppHeader,
    //     default: Offer,
    //     footer: AppFooter
    //   }
    // },
    {
      path: "/integration-software-services",
      name: "integration-software-services",
      components: {
        header: AppHeader,
        default: IntegrationSoftwareServices,
        footer: AppFooter
      }
    },
    {
      path: "/contact-us",
      name: "contact-us",
      components: {
        header: AppHeader,
        default: ContactUs,
        footer: AppFooter
      }
    },
    {
      path: "/sorensen",
      name: "sorensen",
      components: {
        header: AppHeader,
        default: sorensen,
        footer: AppFooter
      }
    },
    {
      path: "/levenshtein",
      name: "levenshtein",
      components: {
        header: AppHeader,
        default: levenshtein,
        footer: AppFooter
      }
    },
    // {
    //   path: "/tensorflow",
    //   name: "tensorflow",
    //   components: {
    //     header: AppHeader,
    //     default: tensorflow,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   }
    // }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
